import { render, staticRenderFns } from "./play.vue?vue&type=template&id=e3ef0150&scoped=true&"
var script = {}
import style0 from "./play.vue?vue&type=style&index=0&id=e3ef0150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ef0150",
  null
  
)

export default component.exports